import { render, staticRenderFns } from "./AcademicProgressMonitoring.vue?vue&type=template&id=3881bf05&scoped=true"
import script from "./AcademicProgressMonitoring.vue?vue&type=script&lang=js"
export * from "./AcademicProgressMonitoring.vue?vue&type=script&lang=js"
import style0 from "./AcademicProgressMonitoring.vue?vue&type=style&index=0&id=3881bf05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881bf05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem})
